const EXTENDED_FILENAME = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i;
const PLAIN_FILENAME = /filename\s*=\s*("([^"]*)"|[^;]+)/i;
const QUOTED_VALUE = /"[^"]*"/g;
const SURROUNDING_QUOTES = /^["“”]+|["“”]+$/g;

// A name a browser could not make sense of is better shown as it came than not at all.
const decoded = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/**
 * The file name a response asks to be saved under; empty when it names none.
 *
 * The extended form (`filename*=UTF-8''…`) wins, as RFC 6266 has it: it is the one that carries the
 * real name, percent-encoded. The plain form beside it is an ASCII stand-in, and one older routes
 * answer with alone, percent-encoded as well.
 */
export const filenameFromContentDisposition = (header: null | string | undefined): string => {
  if (!header) return '';

  // What sits inside a quoted value is a name, not a parameter, whatever it spells.
  const extended = EXTENDED_FILENAME.exec(header.replace(QUOTED_VALUE, '""'))?.[1];

  if (extended) return decoded(extended.trim().replace(SURROUNDING_QUOTES, ''));

  const plain = PLAIN_FILENAME.exec(header);

  if (!plain) return '';

  return decoded((plain[2] ?? plain[1]).trim().replace(SURROUNDING_QUOTES, ''));
};
